var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"fill-height d-flex flex-column justify-center align-center"},[_c('div',[_c('div',{staticClass:"text-center"},[_c('v-progress-circular',{attrs:{"indeterminate":"","color":"primary"}})],1),_c('div',{staticClass:"text-center mt-3"},[_vm._v(" درحال‌ آماده سازی ")])])])
}
var staticRenderFns = []

export { render, staticRenderFns }